import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { TextMaskModule } from 'angular2-text-mask';

import { LoginPage } from './login';

@NgModule({
  declarations: [LoginPage],
  imports: [IonicPageModule.forChild(LoginPage), TextMaskModule],
  exports: [LoginPage],
})
export class LoginPageModule {}



// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts